import DeleteAsrProvider from './DeleteAsrProvider';

type ConfirmModalSubComponents = {
  DeleteAsrProvider: typeof DeleteAsrProvider;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteAsrProvider = DeleteAsrProvider;

export default ConfirmModal;
